<template>
  <div
    class="player-idle-status-line"
    :class="uppercase ? 'player-idle-status-line--uppercase' : undefined"
    role="status"
  >
    <span
      class="player-idle-status-line__dot"
      aria-hidden="true"
    />
    <span><slot /></span>
  </div>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    uppercase?: boolean
  }>(),
  { uppercase: true }
)
</script>

<style scoped>
.player-idle-status-line {
  display: flex;
  align-items: center;
  gap: 0.8vw;
  color: rgba(255, 255, 255, 0.3);
  font-size: clamp(0.55rem, 0.85vw, 0.85rem);
  letter-spacing: 0.18em;
}

.player-idle-status-line--uppercase {
  text-transform: uppercase;
}

.player-idle-status-line__dot {
  display: inline-block;
  width: 0.55em;
  height: 0.55em;
  flex-shrink: 0;
  border-radius: 9999px;
  background: rgba(var(--player-idle-mark-glow-rgb), 0.55);
  animation: player-idle-status-pulse 1.6s ease-in-out infinite;
}

@keyframes player-idle-status-pulse {
  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.45;
  }
}

@media (prefers-reduced-motion: reduce) {
  .player-idle-status-line__dot {
    animation: none;
  }
}
</style>
